export default __webpack_public_path__ + "static/media/banner2.fe5dacc0.jpg";